import { render, staticRenderFns } from "./FolderOfferStep2.vue?vue&type=template&id=72746f5e&scoped=true"
import script from "./FolderOfferStep2.vue?vue&type=script&lang=js"
export * from "./FolderOfferStep2.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferStep2.vue?vue&type=style&index=0&id=72746f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72746f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCombobox,VSwitch})
